class TuziShippingProgress extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.requestController = null;
    this.revision = 0;
    const options = { signal: this.controller.signal };
    this.handleUpdate = (event) => {
      if (event.detail?.data?.didError) return;
      const cart = event.detail?.resource;
      if (cart && Number.isFinite(cart.total_price)) {
        this.revision += 1;
        this.requestController?.abort();
        this.render(cart);
      } else {
        this.refresh();
      }
    };
    for (const name of ['cart:update', 'cart:updated', 'discount:update']) {
      document.addEventListener(name, this.handleUpdate, options);
    }
    this.closest('cart-drawer-component')?.addEventListener('dialog:open', () => this.refresh(), options);
    window.addEventListener('pageshow', () => this.refresh(), options);
    this.refresh();
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.requestController?.abort();
  }
  async refresh() {
    const revision = ++this.revision;
    this.requestController?.abort();
    this.requestController = new AbortController();
    try {
      const response = await fetch(this.dataset.cartUrl, {
        headers: { Accept: 'application/json' }, signal: this.requestController.signal,
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (this.isConnected && revision === this.revision) this.render(cart);
    } catch {
      return;
    }
  }
  render(cart) {
    const threshold = Number(this.dataset.threshold);
    if (!(threshold > 0) || !Number.isFinite(cart.total_price)) return;
    const total = Math.max(0, cart.total_price);
    const remaining = Math.max(0, threshold - total);
    const percentage = Math.min(100, (total / threshold) * 100);
    this.style.setProperty('--tuzi-shipping-progress', percentage + '%');
    this.querySelector('[role="progressbar"]')?.setAttribute('aria-valuenow', String(Math.round(percentage)));
    const amount = this.querySelector('[data-shipping-remaining]');
    if (amount) {
      const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: cart.currency || this.dataset.currency,
      }).format(remaining / 100);
      if (amount.textContent !== formatted) amount.textContent = formatted;
    }
    const pending = this.querySelector('[data-shipping-pending]');
    const success = this.querySelector('[data-shipping-success]');
    if (pending) pending.hidden = remaining === 0;
    if (success) success.hidden = remaining > 0;
  }
}
if (!customElements.get('tuzi-shipping-progress')) {
  customElements.define('tuzi-shipping-progress', TuziShippingProgress);
}
